export default __webpack_public_path__ + "static/media/i7.244ba08f.png";